import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/contract/audit',
    name: 'ContractAudit',
    component: () => import('@/views/contract/audit.vue'),
    meta: {
      title: '合约审核',
      permission: 'contract:audit'
    }
  },
  {
    path: '/contract/list',
    name: 'ContractList',
    component: () => import('@/views/contract/index.vue'),
    meta: {
      title: '合约列表',
      permission: 'contract:list'
    }
  }
]

export default routes
